/**
 * Gets url search query param value.
 * @param {string} queryString.
 * @param {string} param name.
 
 * @returns {string} param value.
 */

export const getUrlQueryParamValue = (queryString, paramName) => {
  const query = new URLSearchParams(queryString);
  return query.get(paramName);
};

/**
 * Gets url search query param value under 'state' param.
 * @param {string} queryString.
 * @param {string} param name.
 
 * @returns {string} param value.
 */

export const getStateParamValue = (queryString, paramName) => {
  const stateParam = getUrlQueryParamValue(queryString, 'state');
  return getUrlQueryParamValue(stateParam, paramName);
};

/**
 * Gets url search query param value or from the 'state' parameter.
 * @param {string} queryString.
 * @param {string} param name.
 
 * @returns {string} param value.
 */

export const getAuthParamValue = (queryString, paramName) =>
  getUrlQueryParamValue(queryString, paramName) ||
  getStateParamValue(queryString, paramName);

/**
 * Parses url pathname.
 * @param {string} pathname.
 
 * @returns {object} params.
 */

export const getParams = (pathname) => {
  const [
    env,
    activitySessionId,
    authenticated,
    edit,
    activityItemId,
    templateId,
    variantId,
  ] = pathname
    .replace(/\/run\//i, '')
    .replace(/\/result\//i, '')
    .split('/');
  return {
    env,
    activitySessionId,
    authenticated,
    edit,
    activityItemId,
    templateId,
    variantId,
  };
};

/**
 * Encodes the parameters into a string to be passed in OAuth2 'state' parameter.
 * @param {object} params.
 * @returns {string} state string.
 */

export const encodeStateParam = (params) => {
  const state = new URLSearchParams();

  // Append only non-null parameters
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      state.append(key, value);
    }
  });

  return state.toString();
};
